var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5861L6.70704 5.29308C6.51844 5.11092 6.26584 5.01013 6.00364 5.01241C5.74144 5.01469 5.49063 5.11985 5.30522 5.30526C5.11981 5.49067 5.01465 5.74148 5.01237 6.00368C5.01009 6.26588 5.11088 6.51848 5.29304 6.70708L10.586 12.0001L5.29304 17.2931C5.11088 17.4817 5.01009 17.7343 5.01237 17.9965C5.01465 18.2587 5.11981 18.5095 5.30522 18.6949C5.49063 18.8803 5.74144 18.9855 6.00364 18.9878C6.26584 18.99 6.51844 18.8892 6.70704 18.7071L12 13.4141L17.293 18.7071C17.4816 18.8892 17.7342 18.99 17.9964 18.9878C18.2586 18.9855 18.5095 18.8803 18.6949 18.6949C18.8803 18.5095 18.9854 18.2587 18.9877 17.9965C18.99 17.7343 18.8892 17.4817 18.707 17.2931L13.414 12.0001L18.707 6.70708C18.8026 6.61483 18.8787 6.50449 18.9311 6.38249C18.9836 6.26048 19.0111 6.12926 19.0123 5.99648C19.0134 5.8637 18.9881 5.73202 18.9379 5.60913C18.8876 5.48623 18.8133 5.37458 18.7194 5.28069C18.6255 5.18679 18.5139 5.11254 18.391 5.06226C18.2681 5.01198 18.1364 4.98668 18.0036 4.98783C17.8709 4.98898 17.7396 5.01657 17.6176 5.06898C17.4956 5.12139 17.3853 5.19757 17.293 5.29308L12 10.5861Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.ce423e48.svg";
export { ForwardRef as ReactComponent };